


















































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OversizedVehicleModal extends Vue {
  public isOpened: boolean = false;

  public open() {
    this.isOpened = true;
  }

  public close() {
    this.isOpened = false;
  }
}
